// alterar arquivo: public/index.html
// checar se existe código do google analytics (apagar ou substituir se for o caso)

// alterar arquivos: .firebaserc (conferir nesse se o default e target apontam para o projeto correto do firebase), firebase.json, package.json e info.txt com o nome do projeto no firebase

// color primary: public/assets/switcher/css/color2.css
// color secondary: public/assets/switcher/css/color2.css: 135

// IDs dos documentos em `revenda` que terão o estoque exibido no site.
// Adicione os IDs das outras lojas nesta lista.
export const ids_firebase = [
  "KFEKSwqT0nDDGXQbpmZI",
  "axA5sJgt85QrAd6gneFI",
  "6bBb57c1avQGq5eavVpU"
];

// Mantém compatibilidade com as telas que exibem os dados da loja principal.
export const id_firebase = ids_firebase[0];
